// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickFilter_container__DlwxU {
  background: var(--foreground-color-1);
  display: flex;
  flex-wrap: wrap;
  border-radius: 0.5em;
}
.ClickFilter_container__DlwxU .ClickFilter_scrollbarThumb__Nbm4u {
  background: var(--background-color-1-alpha);
  border-radius: 100px;
  left: -0.25em;
}
.ClickFilter_container__DlwxU .ClickFilter_mainInputWrap__PYrt8 {
  display: flex;
  flex-grow: 1;
}
.ClickFilter_container__DlwxU .ClickFilter_mainInputWrap__PYrt8 .ClickFilter_mainInput__Aty1Y {
  flex-grow: 1;
}
.ClickFilter_container__DlwxU .ClickFilter_mainInputWrap__PYrt8 .ClickFilter_mainInput__Aty1Y * {
  height: 100%;
}
.ClickFilter_container__DlwxU .ClickFilter_dropdownWrap__zdX3C {
  position: absolute;
  top: 2.5em;
  bottom: 0;
  min-width: 250px;
  width: auto;
  z-index: 1000;
  background: var(--foreground-color-1);
  animation-duration: 0.3s;
  box-shadow: inset 0 6px 5px -5px var(--foreground-color-1-alpha), 1px 5px 5px var(--foreground-color-1-alpha);
  border-right: 1px solid var(--background-color-1);
}
.ClickFilter_container__DlwxU .ClickFilter_dropdownWrap__zdX3C .ClickFilter_dropdown__5hE6u {
  padding: 1em;
  outline: none;
}
.ClickFilter_container__DlwxU .ClickFilter_dropdownWrap__zdX3C .ClickFilter_dropdown__5hE6u > *:not(:last-child) {
  margin-bottom: 1em;
}

.ClickFilter_status__5gtao {
  color: var(--background-color-1);
}`, "",{"version":3,"sources":["webpack://./src/components/ClickFilter/ClickFilter.module.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AACF;AAAE;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;AAEJ;AAAE;EACE,aAAA;EACA,YAAA;AAEJ;AADI;EACE,YAAA;AAGN;AAFM;EACE,YAAA;AAIR;AAAE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,wBAAA;EACA,6GAAA;EAEA,iDAAA;AACJ;AAAI;EACE,YAAA;EACA,aAAA;AAEN;AADM;EACE,kBAAA;AAGR;;AAEA;EACE,gCAAA;AACF","sourcesContent":[".container {\n  background: var(--foreground-color-1);\n  display: flex;\n  flex-wrap: wrap;\n  border-radius: 0.5em;\n  .scrollbarThumb {\n    background: var(--background-color-1-alpha);\n    border-radius: 100px;\n    left: -0.25em;\n  }\n  .mainInputWrap {\n    display: flex;\n    flex-grow: 1;\n    .mainInput {\n      flex-grow: 1;\n      * {\n        height: 100%;\n      }\n    }\n  }\n  .dropdownWrap {\n    position: absolute;\n    top: 2.5em;\n    bottom: 0;\n    min-width: 250px;\n    width: auto;\n    z-index: 1000;\n    background: var(--foreground-color-1);\n    animation-duration: 0.3s;\n    box-shadow: inset 0 6px 5px -5px var(--foreground-color-1-alpha),\n      1px 5px 5px var(--foreground-color-1-alpha);\n    border-right: 1px solid var(--background-color-1);\n    .dropdown {\n      padding: 1em;\n      outline: none;\n      & > *:not(:last-child) {\n        margin-bottom: 1em;\n      }\n    }\n  }\n}\n.status {\n  color: var(--background-color-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ClickFilter_container__DlwxU`,
	"scrollbarThumb": `ClickFilter_scrollbarThumb__Nbm4u`,
	"mainInputWrap": `ClickFilter_mainInputWrap__PYrt8`,
	"mainInput": `ClickFilter_mainInput__Aty1Y`,
	"dropdownWrap": `ClickFilter_dropdownWrap__zdX3C`,
	"dropdown": `ClickFilter_dropdown__5hE6u`,
	"status": `ClickFilter_status__5gtao`
};
export default ___CSS_LOADER_EXPORT___;
